import { IWidgetDefinition, IWidgetSettings, IWidget, IBaseSettings } from '../../common/core';
var template = require("./sort.html");
var styles = require("./sort.scss").toString();

export interface ISortOption {
    field: string,
    order: 'asc' | 'desc',
    label: string,
    default?: boolean;
    disabled?: (w) => boolean;
}

export interface ISortSettings extends IBaseSettings {
    options: ISortOption[]
}

/**
* Settings for sort widget
*/
export interface ISortWidgetSettings extends IWidgetSettings<ISortSettings, null> {
    type: "sort"
}

export class SortData {
    sortBy: string;
    sortOrder: 'asc' | 'desc';
    constructor(public widget: IWidget<SortData, ISortSettings, null>) {
        this.init();
    }

    initSort() {
        var sort = this.widget.service.splitFields(this.widget.service.seriesParam.sort).map(function (p) {
            return (p || '').trim();
        });
        var [sortBy, sortOrder] = sort[sort.length - 1].split(' ');

        var sortByParts = sort.slice(0, sort.length - 1);
        sortByParts.push(sortBy);
        this.sortBy = sortByParts.join(',');
        this.sortOrder = <'asc' | 'desc'>sortOrder;
    }

    init() {
        if (this.widget.settings.options?.length) {
            if (this.widget.service.seriesParam.sort) {
                // supporting complex rules (last order will be in `sortOrder` and everything else in `sortBy`)
                this.initSort();
            } else {
                var defaultOption;
                for (var option of this.widget.settings.options) {
                    if (option.default) {
                        defaultOption = option;
                        break;
                    }
                }
                if (!defaultOption) {
                    defaultOption = this.widget.settings.options[0];
                }

                this.sortBy = defaultOption.field;
                this.sortOrder = defaultOption.order;
            }
            this.widget.service.seriesParam.sort = `${this.sortBy} ${this.sortOrder}`;
        }
    }

    getMatchedItem() {
        var match = this.widget.settings.options?.find(item => {
            return this.sortBy == item.field && this.sortOrder == item.order;
        });
        return match;
    }

    // called outside of sjsearch to refresh internal widget data which may rely on settings
    // returns promise or null
    settingsChanged() {
        this.init();
    }

    setSort(option: ISortOption) {
        if (option.disabled && option.disabled(this.widget)) {
            return;
        }
        if (this.sortBy != option.field || this.sortOrder != option.order) {
            this.sortBy = option.field;
            this.sortOrder = option.order;
            this.widget.service.seriesParam.sort = `${this.sortBy} ${this.sortOrder}`;
            this.widget.service.seriesParam.page = 1;
            this.widget.service.setState();
        }
    }

    getSeparator(last) {
        return last ? '.' : ', ';
    }

    changeSort(params, sortOverride) {
        if (typeof sortOverride === 'string') {
            params.sort = sortOverride;
            this.widget.service.seriesParam.sort = sortOverride;
            this.initSort();
        }
    }

    changeSortIfNecessary(matchedItem, params) {
        if (matchedItem && matchedItem.disabled) {
            var sortOverride = matchedItem.disabled(this.widget);
            this.changeSort(params, sortOverride);
        }
    }

    beforeSearch(params) {
        var matchedItem = this.getMatchedItem();
        this.changeSortIfNecessary(matchedItem, params);
    }
}

const SortWidgetDefinition: IWidgetDefinition<SortData, ISortSettings, null> = {
    init(widget) {
        widget.data = new SortData(widget);
    },
    beforeSearch(widget, params) {
        widget.data.beforeSearch(params);
    },
    getQuery(widget) { },
    getFields(widget) { },
    getFacets(widget) { },
    onData(widget, data) { },
    template: template,
    styles: styles
};

export default SortWidgetDefinition;
